import moment from 'moment';
import id from 'moment/locale/id';

const DateTime = (props) => {
  const { value } = props;
  return `${moment(value).locale('id').format("D MMMM YYYY HH:mm")}`;
}

export default DateTime;